import { render, staticRenderFns } from "./Contactless.vue?vue&type=template&id=f567785e"
import script from "./Contactless.vue?vue&type=script&lang=js"
export * from "./Contactless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports